// extracted by mini-css-extract-plugin
module.exports = {"title":"SectionRecentListings_title__cuwhP","listingCards":"SectionRecentListings_listingCards__xopIa","listingCard":"SectionRecentListings_listingCard__lpXxD"};